import { Alert as ChakraAlert } from "@chakra-ui/react"

export default function Alert({ title, children, indicator, status = 'info', ...props }){
    return(
    <ChakraAlert.Root status={status} {...props}>
        <ChakraAlert.Indicator children={indicator} />
        <ChakraAlert.Content>
          { title && <ChakraAlert.Title children={title} />}
          <ChakraAlert.Description children={children} />
        </ChakraAlert.Content>
      </ChakraAlert.Root>
    )
}